import React from 'react';
import { Alert } from 'ui';

const AiModalError = ({
  hasCodes,
  startAiCodingError,
  destroyError,
  stopError,
  jobHasFailed,
  getErrorMessage,
  gotoUpgrade
}) => {
  const getError = () => {
    if (!hasCodes)
      return 'You need to create codes before you can apply them to this transcript using AI.';

    if (startAiCodingError?.response?.status === 402)
      return (
        <span>
          You have reached the limit of the AI Assistant for your trial.{' '}
          <a onClick={gotoUpgrade}>Upgrade</a> to a paid plan to continue using the AI Assistant.
        </span>
      );

    if (startAiCodingError || destroyError || stopError)
      return (
        getErrorMessage(startAiCodingError) ||
        getErrorMessage(destroyError) ||
        getErrorMessage(stopError)
      );

    if (jobHasFailed)
      return 'There was an error while coding this transcript. Please try again.';
  };

  const errorMessage = getError();
  return <>{errorMessage && <Alert variant="warning">{errorMessage}</Alert>}</>;
};

export default AiModalError;
